import { withNamespaces } from "react-i18next";
import { Button, Spinner } from "reactstrap";
import DataFlowCard from "./DataFlowCard";
import { getCounterpartTypeLabel } from "../helpers/flowCards";

const DataFlowPanel = ({
    title,
    emptyText,
    cards = [],
    isLoading = false,
    methodLabels = {},
    typeLabels = {},
    categoryLabels = {},
    relationLabels = {},
    endpointTypeLabels = {},
    isDeleting = false,
    onAddClick,
    onEdit,
    onDelete,
    t,
}) => {
    return (
        <div className="data-flow-v2__panel">
            <div className="data-flow-v2__panel-header">
                <h6 className="mb-0">{title}</h6>
                <Button
                    color="primary"
                    outline
                    type="button"
                    className="rounded px-4 py-1"
                    onClick={onAddClick}
                >
                    <i className="mdi mdi-plus me-1" aria-hidden="true" />
                    {t("Add Flow")}
                </Button>
            </div>

            {isLoading ? (
                <div className="data-flow-v2__empty-state text-muted">
                    <Spinner size="sm" className="me-2" />
                    {t("Loading...")}
                </div>
            ) : cards.length === 0 ? (
                <div className="data-flow-v2__empty-state text-muted text-center">
                    {emptyText}
                </div>
            ) : (
                <div className="data-flow-v2__card-list">
                    {cards.map((card) => (
                        <DataFlowCard
                            key={card.id}
                            card={card}
                            methodLabels={methodLabels}
                            typeLabels={typeLabels}
                            categoryLabels={categoryLabels}
                            relationLabels={relationLabels}
                            counterpartTypeLabel={getCounterpartTypeLabel(
                                card.counterpart,
                                endpointTypeLabels,
                                t
                            )}
                            isDeleting={isDeleting}
                            onEdit={onEdit}
                            onDelete={onDelete}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default withNamespaces()(DataFlowPanel);
